export default __webpack_public_path__ + "static/media/rocket_anim_28.088d0557.png";